type AppProps = {
  menuDetails: any;
  handleEditMenuDetails: (data: any) => void;
  indentation: number;
  parent:string;
  isEditMenuListPresent: boolean;
};

const NestedTables = ({
  menuDetails,
  handleEditMenuDetails,
  indentation,
  parent,
  isEditMenuListPresent
}: AppProps) => {
  return (
    <>
      <tr>
        <td style={{ paddingLeft: `${indentation * 10}px` }}>
          <span
            className={indentation === 0.7 ? "" : "stock-nested-list no-show"}
          >
            {menuDetails?.menu_name}
          </span>
        </td>
        <td className="text-center">{parent?parent:""}</td>
        <td style={{ width: "80px", textAlign: "center" }}>
          {isEditMenuListPresent && <span
            className="d-inline-block pointer"
            onClick={() => handleEditMenuDetails(menuDetails)}
          >
            <div
              style={{
                color: "#d43",
                fontSize: 20,
              }}
            >
              <i className="fas fa-pen"></i>
            </div>
          </span>}
        </td>
      </tr>
      {menuDetails.sub_menu.length > 0 &&
        menuDetails?.sub_menu.map((dataItem: any) => {
          return (
            <NestedTables
              menuDetails={dataItem}
              handleEditMenuDetails={handleEditMenuDetails}
              indentation={indentation + 1}
              parent={menuDetails.menu_name}
              isEditMenuListPresent={isEditMenuListPresent}
            />
          );
        })}
    </>
  );
};
export default NestedTables;
